import React from "react";
import PropTypes from "prop-types";

export const TypeIcon = (props) => {
  if (props.droppable) {
    return <i className="mdi mdi-folder font-size-16 text-warning" />;
  }

  switch (props.fileType) {
    case "image":
      return <i className="mdi mdi-image font-size-16 text-success" />;
    case "text":
    default:
      return <i className="mdi mdi-file-document font-size-16 text-primary" />;
  }
};

TypeIcon.propTypes = {
  droppable: PropTypes.bool,
  fileType: PropTypes.string
}
